<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">จัดสรรโควต้าให้ร้าน</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        แจกโควต้าหลัก (ฝ่ายอาคาร) → โควต้าร้าน — เฉพาะโหมด via_distributor
      </p>
      <p *ngIf="clientScope.isRestricted()" class="text-xs text-amber-700 dark:text-amber-400 mt-2 flex items-center gap-1">
        <span class="material-icons text-sm">store</span>
        จัดสรรได้เฉพาะร้าน: <span class="font-bold">{{ clientScope.scopeSummaryLabel() }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div class="relative min-w-[200px]">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-amber-500 text-[20px]">place</span>
        <select *ngIf="siteState.sites().length > 1" [ngModel]="selectedSiteId" (ngModelChange)="onSiteChange($event)"
          class="w-full pl-10 pr-4 py-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 text-sm font-bold rounded-xl text-slate-800 dark:text-amber-100 outline-none focus:ring-2 focus:ring-amber-200 h-[46px]">
          <option *ngFor="let site of siteState.sites()" [ngValue]="site.id">{{ site.name }}</option>
        </select>
        <div *ngIf="siteState.sites().length <= 1"
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm font-bold rounded-xl text-slate-700 dark:text-slate-200 h-[46px] flex items-center">
          {{ siteState.selectedSite()?.name || '—' }}
        </div>
      </div>
      <button (click)="onRefresh()" [disabled]="isLoading()"
        class="p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center h-[46px] disabled:opacity-50">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div *ngIf="!isViaDistributor && siteConfig"
    class="animate-fade-in mb-6 p-4 rounded-2xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-200">
    ลานนี้ใช้โหมด <strong>Direct</strong> — ไม่ต้องจัดสรรผ่านฝ่ายอาคาร
    ไปที่ <a routerLink="/system-settings/setting-quota-card" class="underline font-bold">ตั้งค่า Quota Card</a> หากต้องการเปลี่ยนเป็น via_distributor
  </div>

  <div *ngIf="!siteConfig && !isLoading()"
    class="animate-fade-in mb-6 p-4 rounded-2xl bg-rose-50 dark:bg-rose-900/20 border border-rose-200 dark:border-rose-800 text-rose-700 dark:text-rose-200">
    ยังไม่ได้ตั้งค่าโควต้าลาน — ไปที่ <a routerLink="/system-settings/setting-quota-card" class="underline font-bold">ตั้งค่า Quota Card</a> ก่อน
  </div>

  <div *ngIf="requiresAllocationApproval && isViaDistributor"
    class="animate-fade-in mb-6 p-4 rounded-2xl bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200">
    ลานนี้เปิดโหมด <strong>การจัดสรรต้องอนุมัติ</strong> — หลังกดจัดสรร ระบบจะส่งเรื่องไปที่
    <a routerLink="/approval/inbox" class="underline font-bold">กล่องอนุมัติ (49)</a>
    ต้องตั้งค่า workflow ที่ <a routerLink="/system-settings/approval-config" class="underline font-bold">ตั้งค่าอนุมัติ (45)</a> สำหรับเมนูจัดสรรโควต้า (48) ก่อน
  </div>

  <ng-container *ngIf="isViaDistributor">
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
      <!-- ฟอร์มจัดสรร -->
      <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
        <div class="p-6 border-b border-slate-100/50">
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">add_chart</span>
            จัดสรรโควต้าใหม่
            <span class="text-xs font-semibold text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
              {{ siteState.selectedSite()?.name || '—' }}
            </span>
          </h3>
        </div>
        <div class="p-6 md:p-8 space-y-5" [class.opacity-50]="isLoading()">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">โควต้าหลัก (ฝ่ายอาคาร) <span class="text-rose-500">*</span></label>
            <select [(ngModel)]="masterQuotaId" (ngModelChange)="onMasterQuotaChange()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
              <option [ngValue]="null">-- เลือกโควต้าหลัก --</option>
              <option *ngFor="let q of masterQuotas" [ngValue]="q.id">{{ masterLabel(q) }}</option>
            </select>
          </div>

          <div *ngIf="selectedMaster" class="grid grid-cols-3 gap-3">
            <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800 text-center border border-slate-100 dark:border-slate-700">
              <div class="text-xs text-slate-400 font-bold uppercase">อนุมัติ</div>
              <div class="text-lg font-bold text-slate-800 dark:text-slate-100">{{ selectedMaster.quotaApproved }}</div>
            </div>
            <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800 text-center border border-slate-100 dark:border-slate-700">
              <div class="text-xs text-slate-400 font-bold uppercase">แจกแล้ว</div>
              <div class="text-lg font-bold text-slate-800 dark:text-slate-100">{{ selectedMaster.quotaAllocated }}</div>
            </div>
            <div class="p-3 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 text-center border border-emerald-100 dark:border-emerald-800">
              <div class="text-xs text-emerald-600 font-bold uppercase">เหลือแจก</div>
              <div class="text-lg font-bold text-emerald-600">{{ unallocated }}</div>
            </div>
          </div>

          <div class="relative z-20">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ร้านค้า <span class="text-rose-500">*</span></label>
            <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400">store</span>
              <input type="text" [(ngModel)]="clientSearchText" (focus)="openClientDropdown()" (input)="onClientSearchInput()"
                [readonly]="clientScope.isClientLocked()"
                (blur)="closeClientDropdown()" placeholder="ค้นหาและเลือกร้าน..."
                class="w-full pl-10 pr-10 py-2 bg-transparent border-none text-sm font-medium focus:outline-none">
              <button *ngIf="tenantClientId && !clientScope.isClientLocked()" type="button" (mousedown)="$event.preventDefault(); clearClient()"
                class="absolute right-3 text-slate-400 hover:text-rose-500">
                <span class="material-icons text-lg">close</span>
              </button>
            </div>
            <button *ngIf="isClientDropdownOpen" type="button" class="fixed inset-0 z-30 cursor-default"
              (click)="closeClientDropdown()"></button>
            <div *ngIf="isClientDropdownOpen"
              class="absolute top-full mt-2 left-0 right-0 max-h-52 overflow-y-auto bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-40 custom-scrollbar">
              <button *ngFor="let c of clientDropdownOptions" type="button" (mousedown)="$event.preventDefault(); selectClient(c)"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors">
                {{ c.name }}
              </button>
              <div *ngIf="clientDropdownOptions.length === 0" class="px-4 py-3 text-sm text-slate-400 text-center">ไม่พบร้านที่ค้นหา</div>
              <div *ngIf="!clientSearchText.trim() && clients.length > 20" class="px-4 py-2 text-xs text-slate-400 border-t border-slate-100 dark:border-slate-700">
                แสดง 20 รายการแรก — พิมพ์เพื่อค้นหาเพิ่ม
              </div>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จำนวนที่จัดสรร <span class="text-rose-500">*</span></label>
            <input type="number" min="1" [(ngModel)]="allocatedQty"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
            <textarea [(ngModel)]="note" rows="2"
              class="w-full px-4 py-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
          </div>

          <button *ngIf="canCreate" (click)="onAllocate()" [disabled]="isSaving()"
            class="w-full px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg disabled:opacity-50 transition-all">
            {{ isSaving() ? 'กำลังบันทึก...' : (requiresAllocationApproval ? 'ส่งเรื่องจัดสรรเพื่ออนุมัติ' : 'จัดสรรโควต้า') }}
          </button>
        </div>
      </div>

      <!-- สรุปโควต้าร้าน -->
      <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
        <div class="p-6 border-b border-slate-100/50">
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">storefront</span>
            โควต้าร้าน (ย่อย) ปัจจุบัน
          </h3>
          <p class="text-xs text-slate-400 mt-1">สรุปโควต้าที่แจกให้แต่ละร้านแล้ว</p>
        </div>
        <div class="overflow-x-auto max-h-[480px] custom-scrollbar">
          <table class="w-full text-left border-collapse">
            <thead class="sticky top-0 z-10 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
              <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
                <th class="p-4">รายการโควต้า</th>
                <th class="p-4 text-center">อนุมัติ</th>
                <th class="p-4 text-center">ใช้แล้ว</th>
                <th class="p-4 text-center">คงเหลือ</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
              <tr *ngFor="let t of tenantQuotas; trackBy: trackTenantId" class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50">
                <td class="p-4 font-medium text-slate-700 dark:text-slate-200">{{ t.name }}</td>
                <td class="p-4 text-center">{{ t.quotaApproved }}</td>
                <td class="p-4 text-center">{{ t.quotaUsed }}</td>
                <td class="p-4 text-center font-bold text-emerald-600">{{ t.quotaRemaining }}</td>
              </tr>
              <tr *ngIf="tenantQuotas.length === 0">
                <td colspan="4" class="p-8 text-center text-slate-400">
                  <span class="material-icons text-3xl mb-1 block">inventory_2</span>
                  ยังไม่มีโควต้าร้าน — จัดสรรครั้งแรกด้านซ้าย
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- คำขอจัดสรร -->
    <div *ngIf="requiresAllocationApproval"
      class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden mb-6">
      <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-blue-500">pending_actions</span>
            คำขอจัดสรรโควต้า
          </h3>
          <p class="text-xs text-slate-400 mt-1">รายการที่ส่งอนุมัติ — อนุมัติที่เมนู 49</p>
        </div>
        <select [(ngModel)]="filterRequestStatus" (ngModelChange)="onFilterRequestStatusChange()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 min-w-[160px]">
          <option value="">ทุกสถานะ</option>
          <option value="pending">รออนุมัติ</option>
          <option value="approved">อนุมัติแล้ว</option>
          <option value="rejected">ปฏิเสธ</option>
          <option value="cancelled">ยกเลิก</option>
        </select>
      </div>
      <div class="overflow-x-auto min-h-[160px] custom-scrollbar">
        <table class="w-full text-left border-collapse" [class.opacity-50]="isRequestsLoading()">
          <thead class="sticky top-0 z-10 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4">วันที่</th>
              <th class="p-4">เลขที่</th>
              <th class="p-4">โควต้าหลัก</th>
              <th class="p-4">ร้าน</th>
              <th class="p-4 text-center">จำนวนขอ</th>
              <th class="p-4 text-center">สถานะ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
            <tr *ngFor="let row of allocationRequestRows(); trackBy: trackRequestId"
              class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50">
              <td class="p-4 text-xs whitespace-nowrap">{{ row.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="p-4 text-xs font-semibold">{{ row.name }}</td>
              <td class="p-4 text-sm">{{ row.masterQuotaName || '-' }}</td>
              <td class="p-4 font-medium">{{ row.tenantClientName || '-' }}</td>
              <td class="p-4 text-center font-bold">{{ row.requestedQty }}</td>
              <td class="p-4 text-center">
                <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                  [ngClass]="{
                    'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': row.status === 'pending',
                    'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': row.status === 'approved',
                    'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400': row.status === 'rejected',
                    'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300': row.status === 'cancelled'
                  }">{{ requestStatusLabel(row.status) }}</span>
              </td>
            </tr>
            <tr *ngIf="!isRequestsLoading() && allocationRequestRows().length === 0">
              <td colspan="6" class="py-16 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2 block">search_off</span>
                ยังไม่มีคำขอจัดสรร
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4" *ngIf="requestTotalItems() > 0">
        <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
          <span>แสดง {{ requestStartItemIndex | number }} - {{ requestEndItemIndex | number }} จาก {{ requestTotalItems() | number }} รายการ</span>
          <select (change)="onRequestPageSizeChange($event)" [ngModel]="requestPageSize()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="setRequestPage(requestCurrentPage() - 1)" [disabled]="requestCurrentPage() === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <button *ngFor="let p of requestPagesArray" (click)="setRequestPage(p)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
            [ngClass]="p === requestCurrentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50'">{{ p }}</button>
          <button (click)="setRequestPage(requestCurrentPage() + 1)" [disabled]="requestCurrentPage() === requestTotalPages() || requestTotalPages() === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ประวัติการจัดสรร -->
    <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
      <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">history</span>
            ประวัติการจัดสรร
          </h3>
          <p class="text-xs text-slate-400 mt-1">บันทึกการจัดสรรที่อนุมัติและมีผลแล้ว</p>
        </div>
        <select [(ngModel)]="filterMasterQuotaId" (ngModelChange)="onFilterMasterChange()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 min-w-[200px]">
          <option [ngValue]="null">ทุกโควต้าหลัก</option>
          <option *ngFor="let q of masterQuotas" [ngValue]="q.id">{{ q.name }}</option>
        </select>
      </div>

      <div class="overflow-x-auto min-h-[200px] custom-scrollbar">
        <table class="w-full text-left border-collapse" [class.opacity-50]="isAllocationsLoading()">
          <thead class="sticky top-0 z-10 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4">วันที่</th>
              <th class="p-4">โควต้าหลัก</th>
              <th class="p-4">ร้านที่ได้รับ</th>
              <th class="p-4 text-center">จำนวน</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
            <tr *ngFor="let row of allocationRows(); trackBy: trackAllocId"
              class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50">
              <td class="p-4 text-xs whitespace-nowrap">{{ row.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="p-4 text-sm">{{ row.masterQuotaName || '-' }}</td>
              <td class="p-4 font-medium">{{ row.tenantClientName || '-' }}</td>
              <td class="p-4 text-center font-bold">{{ row.allocatedQty }}</td>
            </tr>
            <tr *ngIf="!isAllocationsLoading() && allocationRows().length === 0">
              <td colspan="4" class="py-16 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2 block">search_off</span>
                ยังไม่มีประวัติการจัดสรร
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
          <span>แสดง {{ allocStartItemIndex | number }} - {{ allocEndItemIndex | number }} จาก {{ allocTotalItems() | number }} รายการ</span>
          <select (change)="onAllocPageSizeChange($event)" [ngModel]="allocPageSize()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="setAllocPage(allocCurrentPage() - 1)" [disabled]="allocCurrentPage() === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <button *ngFor="let p of allocPagesArray" (click)="setAllocPage(p)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
            [ngClass]="p === allocCurrentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50'">{{ p }}</button>
          <button (click)="setAllocPage(allocCurrentPage() + 1)" [disabled]="allocCurrentPage() === allocTotalPages() || allocTotalPages() === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<app-pss-loading *ngIf="isLoading() || isSaving()"></app-pss-loading>
